import { render, staticRenderFns } from "./dialog-number.vue?vue&type=template&id=1d1b77b1&scoped=true"
import script from "./dialog-number.vue?vue&type=script&lang=js"
export * from "./dialog-number.vue?vue&type=script&lang=js"
import style0 from "./dialog-number.vue?vue&type=style&index=0&id=1d1b77b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b77b1",
  null
  
)

export default component.exports